// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3i7bs","label":"Section_label__2afs1","contentWrap":"Section_contentWrap__2xXYu","footer":"Section_footer__S49AH","footerInner":"Section_footerInner__32Ghs"};